<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaAcessos(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-btn dark @click="carregaAcessos(user.tipo == 'ADMIN' ? empresaSelecionada : companyobj.id)" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando acessos..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">ACESSOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info" style="margin: 0px">Nenhum acesso encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.tipo`]="{ item }">
            <v-chip :color="pegaCor(item.tipo ? item.tipo : '')" dark>{{ item.tipo ? item.tipo : '---' }}</v-chip>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <td>{{ formatDateHour(item.created) }}</td>
          </template>
          <template v-slot:[`item.foto`]="{ item }">
            <td>
              <v-avatar size="40">
                <v-img v-if="item.foto" :src="item.foto"></v-img>
                <v-icon v-else size="40">mdi-account-circle</v-icon>
              </v-avatar>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar,},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      tabela: {
        cabecalho: [
          { text: 'Foto', value: 'foto', },
          { text: 'Nome', value: 'nome' },
          { text: 'Turma', value: 'turma' },
          { text: 'Sala', value: 'sala' },
          { text: 'Matrícula', value: 'matricula' },
          { text: 'Responsável', value: 'responsavel' },
          { text: 'Destino', value: 'destino' },
          { text: 'Status', value: 'status' },
          { text: 'Horário', value: 'created' },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      empresas: [],
      empresaSelecionada: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },

      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },

      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaAcessos(this.empresaSelecionada)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaAcessos(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaAcessos(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        let whereFilter = {
          "where": {
            "and": [
              {"empresaId": empresaId},
              {"created": {"gte": this.dataInicio + 'T' + this.horaInicio + ':00.000Z'}},
              {"created": {"lte": this.dataFim + 'T' + this.horaFim + ':59.999Z'}}
            ]
          }
        }

        whereFilter = JSON.stringify(whereFilter)

        await axios.get(baseApiUrl + 'Acessos?filter=' + whereFilter + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        if (data_hora) {
          let data = data_hora.substr(0, 10).split('-')
          data = data[2] + '/' + data[1] + '/' + data[0]
          let hora = data_hora.substr(11, 8)
  
          return data + ' às ' + hora
        }
      },

      campoSoma(chave) {
        // soma dados da chave informada
        let valorFinal = 0

        for (let acesso of this.tabela.conteudo) {
          if (acesso.statusPagamento == 'PAGO' && acesso[chave] && parseFloat(acesso[chave].replace(',','.')) > 0) {
            valorFinal += parseFloat(acesso[chave].replace(',','.'))
          }
        }
        
        return valorFinal
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      transformaData(data, formato) {
        return moment(data).format(formato);
      },

      pegaCor(tipo) {
        switch (tipo.toUpperCase()) {
          case 'ENTRADA':
            return 'green';  
          case 'SAIU':
            return 'red';
          default:
            return '#000000';
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
